module.exports = __webpack_public_path__ + "static/media/tachometer-fast.0d5c327d.svg";